/* Pür Motion Engine v1 — auto-tags common Pür homepage elements and choreographs them on scroll.
   Zero dependencies. Bails out entirely under prefers-reduced-motion. */
(function(){
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced || !('IntersectionObserver' in window)) return;
  document.documentElement.classList.add('pm-ready');

  /* 1. scroll progress line */
  var bar = document.createElement('div');
  bar.className = 'pm-progress';
  document.body.appendChild(bar);
  var ticking = false;
  function onScroll(){
    if (ticking) return; ticking = true;
    requestAnimationFrame(function(){
      var h = document.documentElement;
      var max = h.scrollHeight - h.clientHeight;
      bar.style.transform = 'scaleX(' + (max > 0 ? (h.scrollTop || document.body.scrollTop) / max : 0) + ')';
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, {passive:true});
  onScroll();

  /* 2. auto-tag reveal targets (only ones not already animated by their own section code) */
  var riseSel = ['.pv-cards .pv-card', '.pin__col .pini', '.pc-foot', '.pvd-card', '.pp-alt'];
  var scaleSel = ['.pp-card', '.prv-card', '.pin__jarwrap'];
  var wipeSel  = ['.pp-h2', '.prv-h2', '.pc-h2', '.pvd-h2', '.pv-h2'];
  function tag(sels, cls){
    sels.forEach(function(sel){
      document.querySelectorAll(sel).forEach(function(el, i){
        if (el.dataset.pm) return;
        el.dataset.pm = '1';
        el.classList.add(cls);
        el.style.setProperty('--pm-d', Math.min(i * 90, 540) + 'ms');
      });
    });
  }
  tag(riseSel, 'pm-rise');
  tag(scaleSel, 'pm-scale');
  wipeSel.forEach(function(sel){
    document.querySelectorAll(sel).forEach(function(el){ el.classList.add('pm-wipe'); });
  });

  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if (e.isIntersecting){ e.target.classList.add('pm-in'); io.unobserve(e.target); }
    });
  }, {threshold: 0.12, rootMargin: '0px 0px -6% 0px'});
  document.querySelectorAll('.pm-rise, .pm-scale, .pm-wipe').forEach(function(el){ io.observe(el); });

  /* 3. parallax — large media drifts slower than the page (max ±28px, transform-only) */
  var parTargets = [];
  ['.prk-media img', '.pin__jarwrap', '.pur-hero__macro'].forEach(function(sel){
    document.querySelectorAll(sel).forEach(function(el){ el.classList.add('pm-par'); parTargets.push(el); });
  });
  if (parTargets.length){
    var pTick = false;
    function parallax(){
      if (pTick) return; pTick = true;
      requestAnimationFrame(function(){
        var vh = window.innerHeight;
        parTargets.forEach(function(el){
          var r = el.getBoundingClientRect();
          if (r.bottom < -100 || r.top > vh + 100) return;
          var mid = r.top + r.height/2 - vh/2;
          el.style.setProperty('--pm-y', (mid * -0.06).toFixed(1) + 'px');
        });
        pTick = false;
      });
    }
    window.addEventListener('scroll', parallax, {passive:true});
    parallax();
  }
})();
